import React from 'react'
import Navigation from '../components/header/Navigation';
import FaqBody from '../components/body/FaqBody';

const Faq = () => {
    return (
        <React.Fragment>
            <Navigation />
            <FaqBody />
        </React.Fragment>
    )
};

export default Faq;